import {del, get, post, put} from './capitalAxios';

const BASE = '/api/v1/company';

export const findAllCompanies = () => get(BASE);
export const createCompany = (body) => post(BASE, body);
export const updateCompany = (id, body) => put(`${BASE}/${id}`, body);
export const deleteCompany = (id) => del(`${BASE}/${id}`);